/**
 * QuickHighlights — small trio of trust pillars rendered between rails on
 * home (e.g. "Fresh · Halal · Fast").
 */
import React from 'react';
import { css } from '../../design';

const ITEMS = [
  { icon: '🥬', label: 'Fresh produce',  sub: 'Farm-to-doorstep daily' },
  { icon: '🍖', label: 'Halal certified', sub: 'Trusted, premium meat' },
  { icon: '⚡', label: '10-minute prep',  sub: 'From cart to your door' },
];

const QuickHighlights: React.FC = () => (
  <section
    aria-label="Why ProvisionMart"
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 10,
      marginBottom: 24,
    }}
  >
    {ITEMS.map((item, i) => (
      <div
        key={i}
        style={{
          background: css.color.surface,
          border: `1px solid ${css.color.border}`,
          borderRadius: 14,
          padding: '14px 12px',
          textAlign: 'center',
          boxShadow: css.shadow.sm,
        }}
      >
        <div style={{ fontSize: 26, marginBottom: 4, lineHeight: 1 }} aria-hidden>{item.icon}</div>
        <div style={{ fontSize: 13, fontWeight: 700, color: css.color.text }}>{item.label}</div>
        <div style={{ fontSize: 11, color: css.color.textMuted, marginTop: 2 }}>{item.sub}</div>
      </div>
    ))}
  </section>
);

export default QuickHighlights;

